(function(){
    var ns = document.getElementById('tov-beads');
    if(!ns) return;
    var n = 32, spacing = 640/n;
    for(var i=0;i<n;i++){
      var c = document.createElementNS('http://www.w3.org/2000/svg','circle');
      c.setAttribute('cx', (spacing*i + spacing/2).toFixed(1));
      c.setAttribute('cy','11');
      c.setAttribute('r', (i%8===0)?'6':'4.2');
      c.setAttribute('fill', (i%8===0)?'#D9A441':'#8B5E34');
      ns.appendChild(c);
    }
  })();

(function(){
    var ns=document.getElementById('tov-beads2'); if(!ns) return;
    var n=32, spacing=640/n;
    for(var i=0;i<n;i++){
      var c=document.createElementNS('http://www.w3.org/2000/svg','circle');
      c.setAttribute('cx',(spacing*i+spacing/2).toFixed(1)); c.setAttribute('cy','11');
      c.setAttribute('r',(i%5===0)?'6':'4.2'); c.setAttribute('fill',(i%5===0)?'#D9A441':'#7FA187');
      ns.appendChild(c);
    }
  })();

(function(){
    // ---- Countdown to next Shravan Somvar (2026 dates: Aug 3, 10, 17, 24) ----
    var somvars = ["2026-08-03T00:00:00","2026-08-10T00:00:00","2026-08-17T00:00:00","2026-08-24T00:00:00"];
    function nextTarget(){
      var now = new Date();
      for(var i=0;i<somvars.length;i++){
        var t = new Date(somvars[i]);
        if(t > now) return t;
      }
      return new Date(somvars[somvars.length-1]);
    }
    var target = nextTarget();
    function pad(n){ return n<10 ? "0"+n : ""+n; }
    function tick(){
      var now = new Date();
      var diff = Math.max(0, target - now);
      var d = Math.floor(diff/(1000*60*60*24));
      var h = Math.floor((diff/(1000*60*60))%24);
      var m = Math.floor((diff/(1000*60))%60);
      var s = Math.floor((diff/1000)%60);
      var elD=document.getElementById('tov-d'), elH=document.getElementById('tov-h'),
          elM=document.getElementById('tov-m'), elS=document.getElementById('tov-s');
      if(elD){ elD.textContent=pad(d); elH.textContent=pad(h); elM.textContent=pad(m); elS.textContent=pad(s); }
    }
    tick();
    setInterval(tick, 1000);

    // ---- FAQ accordion ----
    var items = document.querySelectorAll('#tov-shravan-lp .faq-item');
    function setHeight(item, open){
      var a = item.querySelector('.faq-a');
      if(open){ a.style.maxHeight = a.scrollHeight + 'px'; item.classList.add('open'); }
      else { a.style.maxHeight = '0px'; item.classList.remove('open'); }
    }
    items.forEach(function(item){
      var open = item.classList.contains('open');
      setHeight(item, open);
      item.querySelector('.faq-q').addEventListener('click', function(){
        var isOpen = item.classList.contains('open');
        setHeight(item, !isOpen);
      });
    });
    window.addEventListener('resize', function(){
      items.forEach(function(item){ if(item.classList.contains('open')) setHeight(item, true); });
    });
  })();